import { createTheme } from '../utils/createTheme';
// Create default global light theme
export default createTheme(() => ({
    mode: 'light',
}));
//# sourceMappingURL=Theme.js.map